import { startOfDay, sub } from 'date-fns';

export const getDateRangePresets = () => {
  const today = startOfDay(new Date());
  return [
    {
      label: 'Today',
      start: today,
      end: today,
    },
    {
      label: 'Last 7 Days',
      start: sub(today, { days: 7 }),
      end: today,
    },
    {
      label: 'Last 1 Month',
      start: sub(today, { months: 1 }),
      end: today,
    },
    {
      label: 'Last 6 Months',
      start: sub(today, { months: 6 }),
      end: today,
    },
  ];
};
